export const N8N_BASE_URL = 'https://n8n.srv1331334.hstgr.cloud/webhook';

export const API_ENDPOINTS = {
    SURVEY_INFO: '/karen/public/survey-instance-info',
    REGISTER: '/karen/public/respondents/create',
    GET_SURVEY: '/karen/public/respondents/get-survey',
    SUBMIT_ANSWERS: '/karen/public/answers/create',
};

export const BRAND_COLORS = {
    DARK: '#133437',
    GOLD: '#baa37e',
    LIGHT: '#f9f7f2',
};
